import { FC } from 'react';
import { PageWrapper } from 'ui/components/PageWrapper';

import { PodiumAvatar } from 'ui/components/PodiumAvatar';
import { ScoreCard } from 'ui/components/ScoreCard';

import secondPlaceImage from 'static/assets/img/mock/1.png';
import firstPlaceImage from 'static/assets/img/mock/2.png';
import thirdPlaceImage from 'static/assets/img/mock/3.png';
import fourthPlaceImage from 'static/assets/img/mock/4.png';
import fifthPlaceImage from 'static/assets/img/mock/5.png';
import sixthPlaceImage from 'static/assets/img/mock/6.png';
import seventhPlaceImage from 'static/assets/img/mock/7.png';
import eighthPlaceImage from 'static/assets/img/mock/8.png';
import { getCheckIcon } from '../../static/assets/icons';
import { useIonRouter } from '@ionic/react';
import { ERoutes } from '../../static/data/ERoutes';

export const LeaderBoardPage: FC = () => {
  const router = useIonRouter();
  return (
    <PageWrapper
      menuProps={{
        mainButtonText: 'Tilbage',
        icon: getCheckIcon(),
        onMainClick: () => router.push(ERoutes.WELCOME, 'root'),
      }}
    >
      <div className="mb-10 flex flex-row justify-center gap-6">
        <button className="underline"> Aftens show </button>

        <button>Tidligere udsendelser</button>
      </div>

      <div className="mb-6 flex flex-row justify-around">
        <PodiumAvatar img={secondPlaceImage} imgSize={20} ranking={2} name="Meghan Jessie" points={40} />
        <PodiumAvatar img={firstPlaceImage} imgSize={28} ranking={1} name="Bryan Wolf" points={43} />
        <PodiumAvatar img={thirdPlaceImage} imgSize={20} ranking={3} name="Alex Turner" points={38} />
      </div>

      <div className="p-4 rounded-3xl bg-primary-tint flex flex-col gap-3">
        <ScoreCard ranking={4} img={fourthPlaceImage} name="Marsha Fisher" points={36} />
        <ScoreCard ranking={5} img={fifthPlaceImage} name="Juanita Cormier" points={35} />
        <ScoreCard className="bg-action" ranking={6} img={sixthPlaceImage} name="Dig" points={34} />
        <ScoreCard ranking={7} img={seventhPlaceImage} name="Sasha, Mika, Thomas og Julie" points={33} />
        <ScoreCard ranking={8} img={eighthPlaceImage} name="Ricardo Veum" points={32} />
      </div>
    </PageWrapper>
  );
};
